import React from 'react'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TourGuiderDetailsMain from '../Components/Guide/TourGuiderDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { api } from '../services/api'
import { usePageBanner } from '../hooks/usePageBanner'

function TourGuiderDetails() {
    const { id } = useParams()
    const { title, bgImage } = usePageBanner({
        itemLoader: api.getGuide,
        itemId: id,
        fallbackTitle: 'Guide Details',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <TourGuiderDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default TourGuiderDetails
